export function ensureDateTime(dateTime) {
    if (dateTime.isValid) {
        return dateTime;
    }
    throw new Error(`Invalid DateTime: ${dateTime.invalidReason}: ${dateTime.invalidExplanation}`);
}
//# sourceMappingURL=TimeUtils.js.map